/**
 * Author: Andrés Aguilar
 * Date: 26/09/2019
 * Modified: 27/09/2019
 * Version: 0.0.2
 */
import Transformer from "../transformer";
import { shortDate } from "../../filters";

class SupplyInPurchaseOrder extends Transformer {
  static fetch(item) {
    const supply = item.supply || {};
    return {
      id: supply.supply_id,
      idOrder: item.id,
      name: item.supply ? supply.supply_name : item.name || "sin nombre",
      description: supply.description,
      unitMeasurement: supply.unit_measurement,
      price: +item.buy_order_price,
      quantity: +item.quantity,
      total: +item.total_price,
      unitPrice: +item.unit_price,
      freightPrice: +item.freight_cost,
    };
  }
}

export default class PurchaseOrderTransformer extends Transformer {
  static fetch(order) {
    const {
        provider, resident
    } = order

    const reviData = resident
      ? {
          residentId: resident.id,
          resident: resident.user.receive_name,
          residentPhone: resident.profile.phone,
          residentCellphone: resident.profile.cellphone,
          residentEmail: resident.profile.alternative_email,
        }
      : {};

    const providerData = provider
      ? {
          providerId: provider.id,
          providerNumber: provider.provider_number,
          providerName: provider.name,
          completeProviderName: `${provider.commercial_name} (${provider.name})`,
          providerPhone: provider.profile.phone,
          providerEmail: provider.profile.email,
        }
      : {};

    return {
      id: order.id,
      file: order.file,
      folio: order.folio,
      addDate: shortDate(order.add_date),
      deliveryDate: shortDate(order.expected_delivery_date),
      status: order.status.status_name,
      sendConditions: order.send_conditions,
      paymentConditions: order.payment_conditions,
      residentValidation: order.resident_validation,
      // Provider data
      ...providerData,
      // Resident
      ...reviData,
      // Supplies
      supplies: order.supplies_consolidated.map(SupplyInPurchaseOrder.fetch),
      // Purchase invoice
      selected: false,
      subtotal: order.subtotal,
      total: order.total,
    };
  }
}



// WEBPACK FOOTER //
// ./src/transformers/purchase/purchaseOrders.js